/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import classnames from 'classnames';
import { ICittaOrderreferenceData } from './citta-orderreference.data';
import { ICittaOrderreferenceProps } from './citta-orderreference.props.autogenerated';
import { Button, IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { computed} from 'mobx';
import { ICartState, getCartState, ICheckoutState, getCheckoutState } from '@msdyn365-commerce/global-state';
import { GetCheckoutCartInput } from '@msdyn365-commerce-modules/retail-actions';
import { updateAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { Cart, AttributeTextValue } from '@msdyn365-commerce/retail-proxy';
import { IModuleStateProps, withModuleState } from '@msdyn365-commerce-modules/checkout-utilities';

interface ICittaOrderReferenceFormState {
    orderreference: string;
    orderreferenceSubmited: string;
    eAValError: boolean;
    eAError: boolean;
    pPCError: boolean;
    rCCError: boolean;
    reqError: boolean;
    responseReceived: boolean;
    responseError: boolean;
    responseSuccess: boolean;
    reCaptchaChecked: boolean;
    submitted: boolean;
}
export interface ICittaOrderReferenceForm {
    FormWrapper: INodeProps;
    FormContainer: INodeProps;
    orderreferenceInput: React.ReactNode;
    submitButtton: React.ReactNode;
    submitThanks: React.ReactNode;
    editButton: React.ReactNode;

}

export interface ICittaOrderreferenceViewProps extends ICittaOrderreferenceProps<ICittaOrderreferenceData> {
    orderreferenceWrapper: IModuleProps;
    orderreferenceResponse: React.ReactNode;
    orderreferenceForm: ICittaOrderReferenceForm;
    responseSuccess: boolean;
    orderreferenceno: React.ReactNode;
}

/**
 *
 * CittaOrderreference component
 * @extends {React.PureComponent<ICittaOrderreferenceProps<ICittaOrderreferenceData>>}
 */
export interface ICittaOrderreferenceModuleProps extends ICittaOrderreferenceProps<ICittaOrderreferenceData>, IModuleStateProps { }
class CittaOrderreference extends React.PureComponent<ICittaOrderreferenceModuleProps, ICittaOrderReferenceFormState> {
    private _OrderRefNoRef: React.RefObject<HTMLInputElement>;
    private moduleClassName: string = 'newsletterSubWrap';
    private responseMessage: string | undefined;
    private orderrefnoValue: boolean = false;
    private formInputValues: boolean = false;
    private cart: ICartState | undefined;
    private checkoutState: ICheckoutState | undefined; 
    @computed public get userorderreferenceno(): Readonly<string | undefined> {
        if (this._OrderRefNoRef.current) {
            return this._OrderRefNoRef.current!.value;
        } else {
            return '';
        }
    }

    constructor(props: ICittaOrderreferenceModuleProps) {
        super(props);
        this._OrderRefNoRef = React.createRef();
        this._handlesubmit = this._handlesubmit.bind(this);
        this.state = {
            orderreference: '',
            orderreferenceSubmited:'',
            eAValError: false,
            eAError: false,
            pPCError: false,
            rCCError: false,
            reqError: false,
            responseReceived: false,
            responseError: false,
            reCaptchaChecked: false,
            responseSuccess: false,
            submitted: false
        };
    }

    public async componentDidMount(): Promise<void> {
        this.props.moduleState.init({
            isRequired: false,
            status: 'ready',
        });
        let cartState = await getCartState(this.props.context.actionContext);
        this.cart = cartState;
        this.checkoutState = await getCheckoutState(this.props.context.actionContext);

        if (this.cart?.cart?.ExtensionProperties!?.length > 0) {

            const property = this.cart?.cart?.ExtensionProperties!?.find((extension) => extension.Key === 'HSOCustRef');
            if (property) {
                if (this._OrderRefNoRef.current) {
                    this._OrderRefNoRef.current!.value = property.Value?.StringValue!;
                    //this.setState({orderreference: property.Value?.StringValue!})
                    //this.setState({orderreferenceSubmited: property.Value?.StringValue!})
                }
            }

        }
    }


    public render(): JSX.Element | null {
        // return this.props.renderView(this.props);       

        const viewProps: ICittaOrderreferenceViewProps = {
            ...(this.props as ICittaOrderreferenceProps<ICittaOrderreferenceData>),
            orderreferenceWrapper: {
                moduleProps: this.props,
                className: classnames(this.moduleClassName)
            },
            orderreferenceResponse: this._getSubscribeResponse(),
            orderreferenceForm: this._renderForm(),
            responseSuccess: this.state.responseSuccess,
            orderreferenceno: this._renderorderreferenceno()
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }

    private _renderorderreferenceno(): React.ReactNode {
        return (
            this.state.orderreferenceSubmited && <span className='referenceOrder' style={{display:"none"}}>Applied value: {this.state.orderreferenceSubmited}</span>
        );
    }

    private _renderSubscribeThanks(): React.ReactNode {
        return (
            <div>
                <div className={'subscribe-thanks'}>
                    Thanks!
                </div>
            </div>
        );
    }
    private _renderForm(): ICittaOrderReferenceForm {
        return {
            FormWrapper: {
                className: 'newsletter-subscription',
            },
            FormContainer: {
                className: 'newsletter-subscription-div',
            },
            orderreferenceInput: this._renderorderreferenceInput(),
            submitButtton: this.state.orderreferenceSubmited ? null : this._renderSubscribeButton(),
            submitThanks: this._renderSubscribeThanks(),
            editButton: this._renderEditButton()
        };
    }

    private _renderSubscribeButton(): React.ReactNode {
        return (
            <div className='ms-checkout__guided-card-footer'>
                <Button
                    title='Save&apply'
                    color='primary'
                    onClick={this._handlesubmit}
                    className='ms-checkout__guided-card-btn-save msc-btn btn-primary'
                >Save & apply
                </Button>
            </div>
        );
    }

    private _renderEditButton(): React.ReactNode {
        return (
            <div>
                <Button
                    title="Edit"
                    color='primary'
                    onClick={this._handleEdit}
                >Edit
                </Button>
            </div>
        );
    }

    private async _handleEdit(e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> | React.FormEvent<HTMLFormElement>): Promise<void> {
        this.orderrefnoValue = (this._OrderRefNoRef && this._OrderRefNoRef.current && this._OrderRefNoRef.current.value) ? true : false;
        this.setState({responseSuccess: false});
    }

    private async _handlesubmit(e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> | React.FormEvent<HTMLFormElement>): Promise<void> {
        this.orderrefnoValue = (this._OrderRefNoRef && this._OrderRefNoRef.current && this._OrderRefNoRef.current.value) ? true : false;

        const eA = (this._OrderRefNoRef && this._OrderRefNoRef.current && this._OrderRefNoRef.current.value) ? this._OrderRefNoRef.current.value : '';
        if (!this.orderrefnoValue) {
            this.setState({
                eAError: true,
                reqError: true
            });
        } else {
            this.formInputValues = (this.orderrefnoValue) ? true : false;
            if (this.formInputValues && !this.state.eAValError) {
                try {
                    await this._SaveExtenstionproperty(eA);
                    //  this._clearValues();
                } catch (e) {
                    console.log(e, 'Please fill the form!');
                }
            }
        }
    }

    // private _clearValues(): void {
    //     if (this._OrderRefNoRef.current) {
    //         this._OrderRefNoRef.current!.value = '';
    //     }
    // }
    private async _SaveExtenstionproperty(orderrefno: string): Promise<void> {

        this._addCartExtension(this.cart?.cart!, "HSOCustRef", orderrefno);
        this._saveCartExtensions(this.cart!, orderrefno);
        this.setState({responseSuccess: true, orderreferenceSubmited: orderrefno});
    }


    private _renderorderreferenceInput(): React.ReactNode {
        return (
            <div className='email-address-input'>
                <label className='ms-checkout-guest-profile__input-label_FNameLabel'></label>
                <input
                    ref={this._OrderRefNoRef}
                    type='email'
                    onChange={this._handleChange('orderrefno')}
                    aria-label='Order Reference No'
                    className='ms-checkout-guest-profile__input-text'
                    value={this.state.orderreference}
                    required
                />
            </div>
        );
    }

    private _handleChange = (name: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({orderreferenceSubmited: ''});
        const value = e.target.value;
        switch (name) {
            case 'orderrefno': {
                this.setState({ orderreference: value, eAError: false, reqError: false, eAValError: false, pPCError: false });
                break;
            }
            default: {
                console.log('No input box changes');
                this.setState({ reqError: false, eAValError: false, pPCError: false });
            }
        }
    }
    private _getSubscribeResponse(): React.ReactNode {
        return (
            this.state.responseReceived && this.responseMessage !== '' || undefined
                ? (
                    <div className={`response-message ${this.state.responseError ? 'response-error' : ''}`}>
                        <p className='response-message-content'>{this.responseMessage}</p>
                    </div>
                )
                : null
        );
    }

    private async _saveCartExtensions(cart: ICartState, orderReferenceString: string) {
        if (!cart) {
            this.props.telemetry.error('No cart object given');
            throw new Error(`saveCartExtensions error: No cart object given`);
        }
        const cartExtensionProperties = cart.cart.ExtensionProperties;
        if (this.checkoutState) {
            let cartAttributes = this.checkoutState.checkoutCart.cart.AttributeValues ?? [];
            let updateCart = true;
			const orderReferenceAttributeName = "HSOCustRef";

            const orderReferenceAttribute = cartAttributes?.find(x => x.Name === orderReferenceAttributeName) as AttributeTextValue;

            if (orderReferenceAttribute) {
                if (orderReferenceAttribute.TextValue !== orderReferenceString) {
                    this.updateTextAttribute(orderReferenceAttribute as AttributeTextValue, orderReferenceString);
                }
                else {
                    updateCart = false;
                }
            } else {
                cartAttributes?.push(this.createTextAttribute(orderReferenceAttributeName, orderReferenceString));
            }

            if (updateCart) {
                await this.checkoutState.checkoutCart.updateAttributeValues({ newAttributeValues: cartAttributes });
            }
        }

        await updateAsync({ callerContext: this.props.context.actionContext }, { Id: cart.cart.Id, ExtensionProperties: cartExtensionProperties }).then(newCart => {
            if (newCart) {
                this.props.context.actionContext.update(new GetCheckoutCartInput(this.props.context.request.apiSettings), newCart);
            }
        }).catch(error => {
            throw new Error(`saveCartExtensions ${error}`);
        });
    }

    private readonly updateTextAttribute = (attribute: AttributeTextValue, value: string) => {
        if (attribute) {
            attribute.TextValue = value;
            attribute.TextValueTranslations = [];
            attribute['@odata.type'] = "#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue";
        } 
        return attribute;
    };

    private readonly  createTextAttribute = (name: string, value: string) => {
        return { 
            Name : name, 
            TextValue: value,
            TextValueTranslations: [],
            '@odata.type': "#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue"
        };
    };

    _addCartExtension = (cart: Cart, key: string, value: string) => {
        cart.ExtensionProperties = cart.ExtensionProperties || [];
        const property = cart.ExtensionProperties.find((extension) => extension.Key === key);
        if (property) {
            property.Value = { StringValue: value };
        } else {
            cart.ExtensionProperties.push({
                Key: key,
                Value: {
                    StringValue: value
                }
            });
        }
    };
}
export default withModuleState(CittaOrderreference);
